module.exports = ":host ::ng-deep .file-tiles .tile {\n  width: calc(33.3% - 0.2rem) !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/files-admin/files-admin.component.scss
// module id = ./src/app/views/files-admin/files-admin.component.scss
// module chunks = main